const carouselItems = [
  {
    tag: '重磅爆料',
    title: '某知名导演被曝剧组潜规则，多位女演员联合发声',
    desc: '近日多位演员在社交平台发布长文，揭露某知名导演在片场的种种不当行为，引发业内广泛关注。51吃瓜网今日吃瓜将持续追踪事件进展。',
    views: '28.6万',
    comments: '1.2万',
    img: 'https://readdy.ai/api/search-image?query=A%20dramatic%20cinematic%20scene%20with%20a%20film%20clapperboard%20on%20a%20dark%20stage%20with%20spotlight%20and%20shadows%2C%20warm%20orange%20and%20deep%20brown%20tones%2C%20mysterious%20atmosphere%2C%20editorial%20photography%2C%20high%20contrast%2C%20clean%20background%20with%20subtle%20texture%2C%20soft%20dramatic%20lighting&width=800&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    tag: '独家追踪',
    title: '某社交平台大规模删帖事件：到底是谁在捂嘴？',
    desc: '昨晚开始多个热门话题在社交平台被批量删除，涉及某知名企业产品质量问题。51吃瓜官网整理了完整的时间线和截图证据。',
    views: '21.3万',
    comments: '9800',
    img: 'https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20screen%20displaying%20social%20media%20content%20with%20warning%20icons%2C%20dark%20atmospheric%20background%20with%20red%20accent%20glow%2C%20dramatic%20editorial%20style%2C%20clean%20minimal%20composition%2C%20high%20detail%2C%20soft%20shadows&width=800&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    tag: '深度报道',
    title: '某档综艺节目录制中嘉宾突然离场，节目组发文致歉',
    desc: '据现场观众爆料，某档热门综艺最新一期录制中，一位嘉宾因不满剪辑导向当场离席。此事迅速登上51吃瓜网今日吃瓜热搜榜首。',
    views: '19.7万',
    comments: '7600',
    img: 'https://readdy.ai/api/search-image?query=A%20television%20studio%20set%20with%20empty%20chairs%20under%20bright%20stage%20lights%2C%20warm%20golden%20and%20amber%20tones%2C%20dramatic%20atmosphere%2C%20editorial%20photography%20style%2C%20clean%20background%2C%20professional%20lighting%20setup%2C%20high%20detail&width=800&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    tag: '瓜田头条',
    title: '某流量明星代言品牌集体解约，背后真相令人咋舌',
    desc: '一周内六个品牌先后宣布与同一艺人终止合作，业内人士透露此事与税务问题有关。51吃瓜官网持续关注每日吃瓜精选动态。',
    views: '32.1万',
    comments: '1.5万',
    img: 'https://readdy.ai/api/search-image?query=A%20luxury%20brand%20billboard%20being%20removed%20from%20a%20modern%20city%20building%20facade%2C%20dramatic%20urban%20scene%20with%20overcast%20sky%2C%20warm%20orange%20and%20muted%20gray%20tones%2C%20editorial%20photography%2C%20clean%20composition%2C%20high%20contrast%2C%20atmospheric&width=800&height=500&seq=carousel-04&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
          <i className="ri-focus-3-line text-primary-500 mr-2 w-6 h-6 inline-flex items-center justify-center align-middle"></i>
          焦点吃瓜专题
        </h2>
        <p className="text-sm text-foreground-500 mb-8">站内热度最高的深度吃瓜专题，一次性完整展示</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4 md:gap-6">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-xl border border-background-200/60 overflow-hidden hover:border-primary-200 transition-colors duration-200 cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="sm:w-2/5 flex-shrink-0">
                <div className="aspect-[16/10] sm:aspect-[4/3] w-full h-full bg-background-100 relative overflow-hidden">
                  <img
                    src={item.img}
                    alt={`焦点吃瓜专题 - ${item.title}`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    onError={(e) => { (e.target as HTMLElement).style.display = 'none'; }}
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2 py-1 bg-primary-500/90 text-background-50 text-[10px] font-bold rounded whitespace-nowrap">{item.tag}</span>
                  </div>
                </div>
              </div>
              <div className="p-4 sm:p-5 flex-1 flex flex-col justify-between">
                <div>
                  <h3 className="text-base font-bold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 mb-2">{item.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3">{item.desc}</p>
                </div>
                <div className="flex items-center gap-4 mt-4 pt-3 border-t border-background-200/40">
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
                    {item.views}
                  </span>
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-chat-3-line w-3 h-3 flex items-center justify-center"></i>
                    {item.comments}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}